import {Lang} from 'yougile-lang'
import {
  ChatMessage,
  ChatMessageJSON,
  ChatMessageStatus,
  DataObjectId,
  Hub,
  HubLike,
  User,
  yougileUser,
  youGileUserId
} from 'yougile-model'
import {Accounts} from '@client/accounts'
import {Sync} from '@client/sync'
import {getLastSeenMessageTime} from './chat'
import {ChatSubscribers} from './chat-subscribers'
import {globals} from './globals-base'

export class ChatMessageUtils {
  public static author(message: ChatMessageJSON, chatHub: HubLike): User {
    if (message.from === youGileUserId) {
      return yougileUser
    }

    return (Sync.getProfile().get(message.from) ||
      Sync.get(chatHub).get(message.from)) as User
  }

  public static authorRealName(message: ChatMessage, chatHub: Hub): string {
    /* TODO (Igor): maybe buggy, will treat any undefined user as YougileTeam */
    const author = ChatMessageUtils.author(message, chatHub) || yougileUser

    return Accounts.getName(author.id, chatHub)
  }

  public static authorRealNameForDisplay(
    message: ChatMessageJSON,
    chatHub: Hub
  ): string {
    /* TODO (Igor): maybe buggy, will treat any undefined user as YougileTeam */
    const author = ChatMessageUtils.author(message, chatHub) || yougileUser

    return Sync.getCurrentUser().id === author.id
      ? Lang.msg.you
      : Accounts.getName(author.id, chatHub)
  }

  public static seenBy(message: ChatMessage, chatHub: Hub): ChatMessageStatus {
    const box = Sync.get(chatHub)
    const userIds = ChatSubscribers.getSubscribedUserIds(chatHub).filter(
      (uid: DataObjectId) =>
        uid !== globals.currentUserId &&
        (chatHub.companyId === Sync.profileId || box.isUserInCompany(uid))
    )
    if (userIds.length === 0) {
      return 'nobody'
    }
    const seenBy = userIds.filter(
      (uid: DataObjectId) =>
        chatHub.chat.getLastSeenMessage(uid) >= message.timestamp
    )
    if (seenBy.length === userIds.length) {
      return 'everybody'
    } else if (seenBy.length === 0) {
      return 'nobody'
    } else {
      return 'some'
    }
  }

  public static wasSeenByCurrentUser(
    message: ChatMessage,
    chatHub: Hub
  ): boolean {
    const currentUserId = globals.currentUserId

    return (
      currentUserId === message.from ||
      message.timestamp <= getLastSeenMessageTime(chatHub)
    )
  }

  public static isFromSameUser(
    source?: ChatMessage,
    target?: ChatMessage
  ): boolean {
    if (!source || !target) {
      return false
    }
    if (source?.properties['guestId'] && target?.properties['guestId']) {
      return source?.properties['guestId'] === target?.properties['guestId']
    }
    if (source.from && target.from) {
      return source.from === target.from
    }
    return false
  }
}
